import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { routeInfo, userCredentials } from 'recoilState/GlobalState';

import s from "styles/pages/Pages.module.scss"
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal, ViewModal } from "./Actions/index";
import { Buttons, HeaderButton } from "components";
import { ACTIONS } from "consts/Actions";
import { Add, Cached, EditOutlined, DeleteOutlineRounded, VisibilityRounded } from '@mui/icons-material';
import { useService, puedeEditarServicio } from 'components/route/ServiceRoute';
import { estructuraConPermisosTitles as titles } from "consts/titulos-de-tablas";
import { etiquetaSiNo } from "consts/banderas";
import XGrid from 'components/UI/Grid/XGrid';
import { RNHEstablecimientoGet } from 'services/services-mia/programa-salud/estructuras/RNHEstablecimientoGet';

export default function Postas() {
  const setRoute = useSetRecoilState(routeInfo);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [hopitales, setHospitales] = useState([]);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} })
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // DESESTRUCTURADO: `useService()` devuelve el contexto del Outlet, que es
  // `{ service }`. Sin las llaves, `service` era ese envoltorio y cualquier campo
  // que se le pidiera daba undefined —incluido `servicioPermiso`, que dejaba los
  // botones de ABM apagados para todos los roles—.
  const { service } = useService()
  const credentials = useRecoilValue(userCredentials);

  const getHospitalesData = async (reset) => {
    setRowSelected({ status: false, row: {} })
    setPage(0)
    setHospitales([]);
    setIsLoading(true);
    const { data: result } = await RNHEstablecimientoGet(credentials, {tipo: 'O'})
    const newRows = result[0]?.rnhEstablecimientoId ? result.map((item) => {
      return {
        id: item.rnhEstablecimientoId,
        tipo: item.rnhEstablecimientoTipo,
        name: item.rnhEstablecimientoNombre,
        cod: item.rnhEstablecimientoCod,
        localidad: item.localidadNombre,
        domicilio: `${item.rnhEstablecimientoCalle} ${item.rnhEstablecimientoNumero}, ${item.localidadNombre}`,
        hospitalAsignado: item.rnhEstablecimientoAsignadoNombre,
        // No son columnas: viajan en la fila para que Modificar, Eliminar y Consultar no
        // tengan que volver a pedir el registro. La response ya los trae todos.
        version: item.rnhEstablecimientoVersion,
        calle: item.rnhEstablecimientoCalle ?? "",
        numero: item.rnhEstablecimientoNumero ?? "",
        cpa: item.rnhEstablecimientoCPA ?? "",
        localidadId: item.rnhEstablecimientoLocalidadId ?? "",
        lat: item.rnhEstablecimientoLatitud,
        lng: item.rnhEstablecimientoLongitud,

        // Los dos permisos, en sus dos formas: la ETIQUETA para la celda y el CRUDO
        // "Y"/"N" que precarga el modal de edicion.
        rotativos: etiquetaSiNo(item.rnhEstablecimientoAdmiteRotativos),
        guardias: etiquetaSiNo(item.rnhEstablecimientoAdmiteGuardias),
        admiteRotativos: item.rnhEstablecimientoAdmiteRotativos,
        admiteGuardias: item.rnhEstablecimientoAdmiteGuardias,
      };
    }) : [];
    setHospitales(newRows);
    setIsLoading(false);
    return {
      rows: newRows,
      rowCount: newRows.length,
    };
  }
  const handleClick = ({ procede, title }) => {
    setModalDetails({ procede, title, isOpen: true });
  };
  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };
  useEffect(() => {
    getHospitalesData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service.servicioNombre])

  useLayoutEffect(() => {
    setRoute({
      wordKey: `Postas Sanitarias`
    })
  }, [service.servicioNombre, setRoute])

  return (
    <main className={s.main}>
      {/* El alta, la modificacion y la consulta abren con size="lg" (900px), la talla pensada para dos columnas con mapa. */}
      <Modal size={modalDetails.procede === ACTIONS.DELETE ? "sm" : modalDetails.procede === ACTIONS.INSERT || modalDetails.procede === ACTIONS.UPDATE || modalDetails.procede === ACTIONS.VIEW ? "lg" : undefined} big={modalDetails.procede === ACTIONS.HISTORY || modalDetails.procede === ACTIONS.VIEW} compact={modalDetails.procede === ACTIONS.DETAIL || modalDetails.procede === ACTIONS.VIEW || modalDetails.procede === ACTIONS.INSERT || modalDetails.procede === ACTIONS.UPDATE} open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
        {modalDetails.procede === ACTIONS.UPDATE && (
          <UpdateModal
            row={rowSelected.row}
            updateList={getHospitalesData}
            closeModal={closeModal}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            row={rowSelected.row}
            servicio={service}
            updateList={getHospitalesData}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
          />
        )}
        {modalDetails.procede === ACTIONS.VIEW && (
          <ViewModal
            row={rowSelected.row}
            servicio={service}
            updateList={getHospitalesData}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
          />
        )}
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            updateList={getHospitalesData}
            closeModal={closeModal}
          />
        )}

      </Modal>
      <div className={s["filters-actions-right"]}>
        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={() => { getHospitalesData() }}
            disabled={rowSelected.row.id || false}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Detalle de la Posta Sanitaria"}
            handleClick={handleClick}
            data={{
              title: `${rowSelected.row.name} - Detalle `,
              procede: ACTIONS.VIEW
            }}
            disabled={!rowSelected.row.id}
          >
            <VisibilityRounded />
          </HeaderButton>
          <HeaderButton
            text={"Nueva Posta Sanitaria"}
            handleClick={handleClick}
            data={{
              title: "Nueva Posta Sanitaria",
              procede: ACTIONS.INSERT
            }}
            disabled={!puedeEditarServicio(service) || (rowSelected.row.id)}
          >
            <Add />
          </HeaderButton>
          <HeaderButton
            text={"Modificar Posta Sanitaria"}
            handleClick={handleClick}
            data={{
              title: "Modificar Posta Sanitaria",
              procede: ACTIONS.UPDATE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <EditOutlined />
          </HeaderButton>
          <HeaderButton
            text={"Eliminar Posta Sanitaria"}
            handleClick={handleClick}
            data={{
              title: "Eliminar Posta Sanitaria",
              procede: ACTIONS.DELETE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <DeleteOutlineRounded />
          </HeaderButton>
        </Buttons>
      </div>

      <div className={s.container}>
        <XGrid
          rows={hopitales}
          titles={titles}
          loading={isLoading}
          updateList={getHospitalesData}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
          page={page}
          setPage={setPage}
        />
      </div>
    </main>
  )
}
